import type { UpdateProfilePayload } from '../types/auth.types';

/**
 * PATCH /api/auth/me — multipart/form-data; chỉ append field có giá trị.
 */
export function buildProfileFormData(payload: UpdateProfilePayload): FormData {
  const fd = new FormData();

  const appendString = (key: string, value: string | undefined) => {
    if (value === undefined || value === '') return;
    fd.append(key, value);
  };

  appendString('display_name', payload.display_name);
  appendString('full_name', payload.full_name);
  appendString('birth_date', payload.birth_date);
  appendString('gender', payload.gender);
  appendString('avatar_url', payload.avatar_url);
  appendString('phone', payload.phone);
  appendString('email', payload.email);
  appendString('department_id', payload.department_id);
  appendString('academic_rank_id', payload.academic_rank_id);
  appendString('academic_degree_id', payload.academic_degree_id);
  appendString('position_id', payload.position_id);
  appendString('professional_title_id', payload.professional_title_id);

  if (payload.data_scope && typeof payload.data_scope === 'object') {
    fd.append('data_scope', JSON.stringify(payload.data_scope));
  }

  if (payload.avatar instanceof File) {
    fd.append('avatar', payload.avatar);
  }

  return fd;
}
